import { decode } from 'html-entities';

export const computedExtensionDefaults = {
  computed: {
    $meta() {
      return this.data?.meta;
    },
    $teaser() {
      return this.data?.teaser;
    },
    $extension() {
      return this.data?.extension;
    },
    $isExternal() {
      return this.$teaser?.link?.target === 'external';
    },
    $title() {
      if (!this.$teaser?.title) return undefined;
      return decode(this.$teaser.title);
    },

    $description() {
      if (!this.$teaser?.description) return undefined;
      return decode(this.$teaser.description);
    },
  },
};
